var educationNav = document.getElementById('SiteNavLabel-education');

// Check if the element exists
if (educationNav) {
  // Find the closest parent <li> element with the class "site-nav--has-dropdown"
  var parentLi = educationNav.closest('li.site-nav--has-dropdown');

  // Add the additional class "arif" to the <li> element
  if (parentLi) {
    parentLi.classList.add('hide-alogfy-custom');
  }
}



if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

jQuery(document).ready(function () {
  var mf = "";
  //console.log(mf);
  $('.month-inr').click(function () {
    $('.month-inr').removeClass('active');
    $(this).addClass('active');
  });

  function subscriptionbox() {
    $('.refill.months-refill').show();
    $('.input-wrap .desdif.refill').show();
    $('.input-wrap .add-viberinpt.refill').prop('checked', true).addClass('active_id');
    $('.addtocart').addClass('subscription_btn');
    $('.sub_hide_p').hide();
  }
  function normalbox() {
    $('#refil1').removeClass('active_id');
    $('.refill.months-refill').hide();
    $('.input-wrap .desdif.refill').hide();
    $('.input-wrap .add-viberinpt.refill').prop('checked', false);
    $('.addtocart').removeClass('subscription_btn');
    $('.sub_hide_p').show();
  }
  $('#refil1').click(function () {
    subscriptionbox();
    var main_price = $('.title-nprice').attr('data-pricetotal');
    var total = 0;
    $('.active_id').each(function () {
      var price = $(this).closest('.add-vibrator').find('.price_p').attr('data-pricetotal');
      total = parseInt(total) + parseInt(price);
    })
    var total_main = parseInt(total) + parseInt(main_price)
    $('.total_price').text(Shopify.formatMoney(total_main, mf));
    $('.refer_total').text(Shopify.formatMoney(total, mf));
    $('.product-type-inner').addClass('active');
    setTimeout(function () {
      $('.afterpay-paragraph').hide();
    }, 50);
  });
  $('#refil2').click(function () {
    normalbox();
    $('.product-type-inner').removeClass('active');
    setTimeout(function () {
      $('.afterpay-paragraph').show();
    }, 50);
  });
  $('.add-vibrator .refill').click(function () {

    $('#refil1').prop('checked', true);
    $('.refill.months-refill').show();
    var cur = $(this).parent('.input-wrap').attr('data-class');
    if ($(this).hasClass('active_id')) {
      $(this).closest('.add-vibrator').find('.sub_hide_p').show();
      $(this).prop('checked', false).removeClass('active_id');
      $(this).closest('.add-vibrator').find('.desdif').hide();
      $('.product-type-inner.' + cur).removeClass('active');

    } else {
      $('.product-type-inner.' + cur).addClass('active');
      $(this).prop('checked', true).addClass('active_id');
      $(this).closest('.add-vibrator').find('.sub_hide_p').hide();
      $(this).closest('.add-vibrator').find('.desdif').show();

    }
    var main_price = $('.title-nprice').attr('data-pricetotal');
    var total = 0;
    $('.active_id').each(function () {
      var price = $(this).closest('.add-vibrator').find('.price_p').attr('data-pricetotal');
      total = parseInt(total) + parseInt(price);
    })
    var total_main = parseInt(total) + parseInt(main_price)
    $('.total_price').text(Shopify.formatMoney(total_main, mf));
    $('.refer_total').text(Shopify.formatMoney(total, mf));
    if ($('.active_id').length == 0) {
      $('#refil2').prop('checked', true);
      normalbox();
    }
    if ($('input.refill:checked').length) {
      $('.addtocart').addClass('subscription_btn');
    } else {
      $('.addtocart').removeClass('subscription_btn');
    }
  });


  $('.vibe-video.v1 .play-vid-button').click(function () {
    $("#vibevidv1").get(0).play();
    $('.vibe-video.v1').addClass('active');
  });
  $('.vibe-video.v1 > video').click(function () {
    $("#vibevidv1").get(0).pause();
    $('.vibe-video.v1').removeClass('active');
  });

  $('.vibe-video.v2 .play-vid-button').click(function () {
    $("#vibevidv2").get(0).play();
    $('.vibe-video.v2').addClass('active');
  });
  $('.vibe-video.v2 > video').click(function () {
    $("#vibevidv2").get(0).pause();
    $('.vibe-video.v2').removeClass('active');
  });

  $('body').on('click', '.vibe-video.v3 .play-vid-button', function () {
    $("#vibevidv3").get(0).play();
    $('.vibe-video.v3').addClass('active');
  })
  $('.vibe-video.v3 > video').click(function () {
    $("#vibevidv3").get(0).pause();
    $('.vibe-video.v3').removeClass('active');
  });

  $('.vibez-bts-popup').click(function () {
    $('.refil-popup.p3').addClass('active');
    $('.popupoverlay').addClass('active-popup');
    $('.popupoverlay,.product-hero').addClass('active-popup');
  });
  $('.refilpop').click(function () {
    $('.refil-popup.p1').addClass('active');
    $('.popupoverlay').addClass('active-popup');
    $('.popupoverlay,.product-hero').addClass('active-popup');
  });
  $('.cocoilpop').click(function () {
    $('.refil-popup.p2').addClass('active');
    $('.popupoverlay,.product-hero').addClass('active-popup');
  });
  $('.popup-close,.popupoverlay').click(function () {
    $('.refil-popup').removeClass('active');
    $('.popupoverlay,.product-hero').removeClass('active-popup');
  });
  $('.relief-topright').click(function () {
    $('.refil-popup.p4').addClass('active');
    $('.popupoverlay,.product-hero').addClass('active-popup');
  });
  $('.popup-close,.popupoverlay').click(function () {
    $('.refil-popup').removeClass('active');
    $('.popupoverlay,.product-hero').removeClass('active-popup');
  });

  // This button will increment the value
  $('.qtyplus').click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(0);
    }
  });


  /*******popup cart*****************/
  /*  $(".desktop_cart").click(function(){
$('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');

});
 $(".cart-popup__close").click(function(){
$('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');

});

    */

  /*******end popup cart*****************/
  $('.product-q').click(function (e) {
    e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.removeClass('active');
    } else {
      $this.parent().parent().find('.product-a').removeClass('show');
      $this.parent().parent().find('.product-q').removeClass('active');
      $this.next().toggleClass('show');
      $this.addClass('active');
    }
  });

  $(function () {


    $('.pro-dtl-wrap .content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 540,
          settings: 'unslick'
        }
      ]
    });

    $(window).on('resize', function () {
      $('pro-dtl-wrap .content').slick('resize');
    });
  });

  $('.product-main-img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    focusOnSelect: false,
    asNavFor: '.product-img-nav'
  })
  $('.product-img-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    vertical: true,
    asNavFor: '.product-main-img',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          centerMode: false,
          vertical: false,
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      }
    ]
  });
  if ($('.gallery-img').slick) {
    $('.gallery-img').slick({
      speed: 300,
      arrows: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    })
  };




  if ($('#vibez-images').length > 0) {
    $('#vibez-images').slick({
      arrows: false,
      autoplay: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            adaptiveHeight: true
          }
        },
        {
          breakpoint: 681,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }


  // $(function() {
  //   $('.review-slider').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     mobileFirst: true,
  //     arrows: false,
  //     dots: false,
  //     responsive: [
  //       {
  //         breakpoint: 767,
  //         settings: 'unslick'
  //       }
  //     ]
  //   });

  //   $(window).on('resize', function() {
  //     $('.review-slider').slick('resize');
  //   });
  // });
  // $(function() {
  //   $('.pro-dtl-wrap .content').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     mobileFirst: true,
  //     arrows: true,
  //     dots: false,
  //     responsive: [
  //       {
  //         breakpoint: 540,
  //         settings: 'unslick'
  //       }
  //     ]
  //   });

  //   $(window).on('resize', function() {
  //     $('pro-dtl-wrap .content').slick('resize');
  //   });
  // });
  $('.productimg').slick({
    arrows: true,
    centerMode: false,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: 5,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      }

      // You can unslick at a given breakpoint now by adding:
      //     settings: "unslick"
      // instead of a settings object
    ]

  });

  $('.productimg-home-mobile').slick({
    arrows: true,
    centerMode: true,
    mobileFirst: true,
    infinite: true,
    slidesToShow: 2,

  });



  $('.productimg-mobile-product').slick({
    arrows: true,
    centerMode: true,
    mobileFirst: true,
    infinite: true,
    slidesToShow: 2,

  });


  $('.productimg1').slick({
    arrows: false,
    autoplay: true,
    centerMode: true,
    mobileFirst: true,
    infinite: true,
    centerPadding: '0px',
    slidesToShow: 1,

  });

  $('.quotes-slider-mobile').slick({
    arrows: true,
    autoplay: false,
    centerMode: true,
    mobileFirst: true,
    infinite: true,
    centerPadding: '0px',
    slidesToShow: 1,

  });

  $(".sidebar-faq").on("click", function () {
    var dataId = $(this).attr("data-id");
    $('html, body').animate({
      scrollTop: $("#" + dataId).offset().top
    }, 1000);
  });

  //quickview
  function refreshCart(cart) {
    $('#CartCount span').text(cart.item_count);
  }

  function closePopup() {
    $('body').removeClass('qvopen');
    $('.popupBox').removeClass('slideInDown');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
  }
  function openPopup(a) {
    $('body').addClass('qvopen');
    $('.popupBox').addClass('slideInDown');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.' + a).fadeIn('slow');
  }
  $('body').on('click', '.popupinfo', function (e) {
    console.log('INNNNN');
    e.preventDefault();
    var id = $(this).data('href');
    openPopup(id);
  });
  $('body').on('click', '.cls_popup, .qv_popup_overly', function (e) {
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      closePopup();
    }
  });
  window.onclick = function (e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }
  }

  /* Quick VIew */
  $('body').on('click', '.openQv', function (m) {
    m.preventDefault();
    var qvbtn = $(this);
    $(this).attr('disabled', 'disabled');
    qvbtn.html('...');
    var url = $(this).attr("data-href");
    $.get(url, function (data) {
      $('#qvProductContent').html(data);
      openPopup('qvPopup');
      $('.puList').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false
      });

      $('.qv_main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: true,
        asNavFor: '.qv_thumb',
        prevArrow: '<button type="button" title="Prev" class="slick-prev qview-slider__prev"><svg aria-hidden="true" viewBox="0 0 512 512" class=""><path fill="currentColor" d="M358 512c4 0 7-1 9-4 5-5 5-13 0-18L146 269 367 47c5-5 5-13 0-18s-13-5-18 0L119 260c-5 5-5 13 0 18l230 230c3 3 6 4 9 4z"></path></svg></button>',
        nextArrow: '<button type="button" title="Next" class="slick-next qview-slider__next"><svg aria-hidden="true" viewBox="0 0 512 512" class=""><path fill="currentColor" d="M128 512c-3 0-7-1-9-4-5-5-5-13 0-18l221-221L119 47c-5-5-5-13 0-18s13-5 18 0l230 231c5 5 5 13 0 18L137 508c-2 3-6 4-9 4z"></path></svg></button>'
      });
      $('.qv_thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        asNavFor: '.qv_main',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        verticalSwiping: true
      });

      $('.addtocartFormqv').on('submit', function (e) {
        e.preventDefault();
        var form = $(this);
        form.find('.qview-response').remove();
        form.find('#AddToCart').attr('disabled');
        form.find('#AddToCart span').text('Adding..');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: form.serialize(),
          dataType: 'json',
          error: function (jqXHR, textStatus, errorThrown) {
            var response = $.parseJSON(jqXHR.responseText);
            form.append('<p class="error">' + response.description + '</p>').find('.error').fadeIn().delay(4000).fadeOut();
            form.find('#AddToCart span').text('add to cart');
            form.find('#AddToCart').removeAttr('disabled');
          }
        }).done(function (data) {
          //$.getJSON('/cart.js', function(cart){
          Shopify.getCart(function (cart) {
            refreshCart(cart);
          });
          form.find('#AddToCart').removeAttr('disabled');
          form.find('#AddToCart span').text('Add to Cart');
          form.append('<div class="qview-response">This item has been added to cart! <a href="#" class="mobilehide site-nav__link site-nav__link--main cart-link qikify-openc">View cart</a> or <a href="/collections/all-products-1">Continue shopping</a></div>');
        });
      });
      qvbtn.html('<div class="quick_icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="-139 144 20 13" class=""><path d="M-119.3 150.2c-.2-.2-4.4-6-9.8-6s-9.6 5.8-9.8 6c-.2.2-.2.5 0 .8.2.2 4.4 6 9.8 6s9.6-5.8 9.8-6c.1-.3.1-.6 0-.8zm-9.8 5.5c-4 0-7.4-3.8-8.4-5.1 1-1.3 4.4-5.1 8.4-5.1s7.4 3.8 8.4 5.1c-1 1.2-4.4 5.1-8.4 5.1z"></path><path d="M-129.1 146.6c-2.2 0-3.9 1.8-3.9 4s1.8 4 3.9 4c2.2 0 3.9-1.8 3.9-4s-1.7-4-3.9-4zm0 6.6c-1.4 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6c0 1.4-1.2 2.6-2.6 2.6z"></path></svg></div><div class="quick_text">Quick view</div>');
      // alert('hlo');
    });

    $('.openQv').removeAttr('disabled');
  });
  /* Quick View */

  $('body').on('click', '.qview-description__show-more', function (e) {
    e.preventDefault();
    $('.quickview_desc').addClass('full_desc');
    $('.qview-description__footer span').removeClass('hide_it');
    $(this).addClass('hide_it');
  });
  $('body').on('click', '.qview-description__show-less', function (e) {
    e.preventDefault();
    $('.quickview_desc').removeClass('full_desc');
    $('.qview-description__footer span').removeClass('hide_it');
    $(this).addClass('hide_it');
  });
  $('body').on('click', '.change_qty', function (e) {
    e.preventDefault();
    var input = $(this).parent().find('input');
    var cnt = input.val();
    if ($(this).hasClass('qview-input-plus')) {
      cnt++;
    } else {
      cnt--;
    }
    if (cnt > 0) {
      input.val(cnt);
    }
  });



});
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 2110) {
    $(".images_call").removeClass("three");
  }
  if (scroll >= 1200 && (scroll <= 2110)) {
    $(".images_call").addClass("two");
  }
  if (scroll >= 1900 && (scroll <= 2110)) {
    $(".images_call").removeClass("two");
    $(".images_call").addClass("three");
  }
  if ((scroll >= 614) && (scroll <= 1200)) {
    $(".images_call").addClass("one");
    $(".images_call").removeClass("two");
    $(".images_call").removeClass("three");
  } else if ((scroll >= 1200) || (scroll <= 614)) {
    //console.log('a');
    $(".images_call").removeClass("one");
  }
});

/*$( document ).ready(function() {
  $(window).scroll(function() {
   var hT = $('#left-content-1').offset().top,
       hH = $('#left-content-1').outerHeight(),
       hT2 = $('#left-content-2').offset().top,
       hH2 = $('#left-content-2').outerHeight(),
       hT3 = $('#left-content-3').offset().top,
       hH3 = $('#left-content-3').outerHeight(),
       wH = $(window).height(), 
       wS = $(this).scrollTop();
   if (wS > (hT+hH-wH)){
       $("#right-image-3").hide();
        $("#right-image-2").hide();
        $("#right-image-1").show();
   }
    if (wS > (hT2+hH2-wH)){
       $("#right-image-3").hide();
        $("#right-image-2").show();
        $("#right-image-1").hide();
   }
     if (wS > (hT3+hH3-wH)){
       $("#right-image-1").hide();
        $("#right-image-3").show();
        $("#right-image-2").hide();
   }
}); 
});*/



/******************************/


// $( document ).ready(function() {
//   var bodyEl = $("#shopify-section-about-us-all");
//   $(window).on("scroll", function() {
//     var scrollTop = $(this).scrollTop();
//     console.log(scrollTop);
//     $(".right-image").each(function() {
//       var el = $(this);
//       var className = el.attr("id");
//       console.log(className);
//       if (el.offset().top < scrollTop) {
//         $('.images_call').addClass('fix');

//       } else {
//         $('.images_call').removeClass('fix');

//       }
//     });
//   });
// });

$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  //console.log(scroll);
  if ((scroll >= 3420) && (scroll <= 3716)) {
    $(".images_call1").addClass("two");
  }
  if ((scroll >= 3426) && (scroll <= 3982)) {
    $(".images_call1").removeClass("two");
    $(".images_call1").addClass("one");
  }
  if (scroll >= 2700 && (scroll <= 3887)) {
    $(".images_call1").removeClass("two");
  }
  else if ((scroll >= 3383) || (scroll <= 3420)) {
    //console.log('a');
    $(".images_call1").removeClass("one");

  }
});

//function playVid(){
//  if(window.location.pathname == "/"){
//    var w = document.documentElement.clientWidth;
//    if(w >= 750){
//     document.getElementById('bgvid1').pause();
//     document.getElementById('bgvid').play();
//    }else{
//      jQuery('.rte.rte-setting.featured-roww__subtext .subtext-mobile-change').html('<p style="text-align:center;">Welcome to the land of better sex,</br>where it’s all on your terms.<br> No shame, no taboo, just great,<br>healthy sex. So, what are you into?</p>')
//      document.getElementById('bgvid1').play();
//      document.getElementById('bgvid').pause();
//    }
//  }
//}

//window.addEventListener("resize", playVid);


jQuery('document').ready(function () {
  /*video on screen size*/
  //  if (window.location.pathname == "/"){
  //    if(jQuery(window).width() >= 750){
  //     document.getElementById('bgvid1').pause();
  //     document.getElementById('bgvid').play();
  //    }else{
  //      document.getElementById('bgvid1').play();
  //      document.getElementById('bgvid').pause();
  //    }
  //  }
  /*video button*/
  //  jQuery('.player-overlay-mute').on('mousedown', function(){
  //    if(jQuery('#bgvid').prop('muted') == true ){
  //      document.getElementById('bgvid').muted = false;
  //    }else{
  //      document.getElementById('bgvid').muted = true;
  //    }
  //  })
  //  jQuery('.player-overlay-mute-mobile').on('mousedown', function(){
  //    if(jQuery('#bgvid1').prop('muted') == true ){
  //      document.getElementById('bgvid1').muted = false;
  //    }else{
  //      document.getElementById('bgvid1').muted = true;
  //    }
  //  })
  /*menu handling*/
  $(window).scroll(function () {
    if (window.location.pathname == "/") {
      if ($(this).scrollTop() >= 100) { // this refers to window
        //alert('123');
        jQuery('nav.mobile-nav-wrapper.medium-up--hide.js-menu--is-open').css('top', '100px');
        jQuery('nav.mobile-nav-wrapper.medium-up--hide.js-menu--is-open').css('position', 'fixed');
      } else {
        jQuery('nav.mobile-nav-wrapper.medium-up--hide.js-menu--is-open').css('top', '0');
        jQuery('nav.mobile-nav-wrapper.medium-up--hide.js-menu--is-open').css('position', 'relative');
      }
    }
  });
  /*custom url bundles*/
  jQuery('[href="/collections/shop-all/products/bundles-1"]').each(function () {
    jQuery(this).prop('href', 'https://woomoreplay.com/collections/bundles');
  })

});

$('#rc_autodeliver_options').append("<div class='product_sub_options'><label class='prod_sub_lbl'>Ship Every</label><div class='prod_sub_items'><span class='one_month prod_sub_item'>1 month</span><span class='two_month prod_sub_item'>2 months</span><span class='three_month prod_sub_item '>3 months</span></div></div>");
$('.one_month').click(function () {
  $(".rc_select__frequency ").val('1');
  $('.prod_sub_item').removeClass('active-sub');
  $(this).addClass('active-sub');
});
$('.two_month').click(function () {
  $(".rc_select__frequency ").val('2');
  $('.prod_sub_item').removeClass('active-sub');
  $(this).addClass('active-sub');
});
$('.three_month').click(function () {
  $(".rc_select__frequency ").val('3');
  $('.prod_sub_item').removeClass('active-sub');
  $(this).addClass('active-sub');
});

//jQuery(document).ready(function(){console.log('');})




if (jQuery('.product-single__title').html() == 'Coconut Love Oil') {
  $(".rc_block__type__autodeliver  .rc_select__frequency ").val('2');
  $('.two_month').trigger('click');
} else {
  $('.one_month').trigger('click');
}


jQuery(document).ready(function () {
  jQuery('.bfx9').on('click', function () {
    jQuery('button.shopify-buy__btn--close').click();
  });
  //   $('.feature').addClass('loaded');

})

window.onload = function () {
  $('.feature').css('display', 'block');
  var v_id = $('#shopify-section-viber-video-new .vibe-video').attr('data-video');
  console.log('video', v_id);
  $('#shopify-section-viber-video-new .vibe-video').append('<video playsinline="" muted="" loop="" poster="" id="vibevidv3"><source src="' + v_id + '" type="video/mp4"><source src="' + v_id + '" type="video/ogg"></video> <div class="play-vid-button"><img src="https://cdn.shopify.com/s/files/1/2042/4737/files/play-vidbutton.png?v=1598683606" alt="icon"></div>');

  //   $('[data-loadsrc]').each(function(){
  //     var f = $(this).attr('data-loadsrc');
  //     $(this).attr('src',f);
  //   });

  //   $('.feature .feature-content').css('opacity', 1)

}
/*$(window).scroll(function() {
   var hTT = $('#right1-content-1').offset().top,
       hHH = $('#right1-content-1').outerHeight(),
       hT2 = $('#right1-content-2').offset().top,
       hH2 = $('#right1-content-2').outerHeight(),
       wHH = $(window).height(), 
       wSS = $(this).scrollTop();
   if (wSS > (hTT+hHH-wHH)){
        $("#left1-image-2").hide();
        $("#left1-image-1").show();
   }
    if (wSS > (hT2+hH2-wHH)){
        $("#left1-image-2").show();
        $("#left1-image-1").hide();
   }
});*/

var reChargeLabel = (function () {

  $('body').on('click', '.rc-radio', function (e) {

    $plans = $(this).find('.rc-selling-plans__label')[0];
    $plansLabel = $(this).find('.rc-selling-plans__label')[0];

    if (e.target == this || e.target == $plans || e.target == $plansLabel) {
      $(this).find('input').trigger('click');
    }

  });

}());

